import React, { Component } from "react";
import { StripeProvider, Elements } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import InjectedMainForm from "../MainForm";
import { connect } from "react-redux";
import {
  getUserSubscriptionDetails,
  clearSubscriptionDetails,
} from "../../../reducers/subscriptionDetails/actions";
import Spinner from "../../Spinner";
import Error from "../../Error";
import messages from "../../../lang/default-messages";
import { ECOMMERCE_ALREADY_SUBSCRIBED } from "../../../telemetry/constants";
import { log } from "../../../telemetry/analytics";
import { handleAnalyticsConsent } from "../../../osano";

export class CheckoutContainer extends Component {
  state = {
    stripe: null,
  };

  goToThankYou = () => this.props.history.push("/store/thank-you");

  componentDidMount() {
    const stripe = window.Stripe(this.props.stripeApiKey);
    this.setState({ stripe });
    this.props.getUserSubscriptionDetails();
  }

  componentWillUnmount() {
    this.props.clearSubscriptionDetails();
  }

  render() {
    const { userSubscriptionDetails } = this.props;

    // Show spinner while details are fetching
    if (userSubscriptionDetails.isFetching) {
      return <Spinner className="my-3" />;
    }
    //Check if already subscribed user
    if (
      userSubscriptionDetails.hasFetched &&
      userSubscriptionDetails.data.length > 0 &&
      userSubscriptionDetails.data[0].status === "active"
    ) {
      const subscribedProfile =
        userSubscriptionDetails.data[0].subscriptionName ===
        "DynaMedex Subscription"
          ? "dmx"
          : "dmp";

      handleAnalyticsConsent(() => log(ECOMMERCE_ALREADY_SUBSCRIBED, {}));

      return (
        <Error
          title={messages[`alreadySubscribed${subscribedProfile}`].title}
          message={messages[`alreadySubscribed${subscribedProfile}`].message}
        />
      );
    }
    // All is well! Render the Checkout Page
    return (
      <StripeProvider stripe={this.state.stripe}>
        <Elements>
          <InjectedMainForm goToThankYou={this.goToThankYou} />
        </Elements>
      </StripeProvider>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserSubscriptionDetails,
      clearSubscriptionDetails,
    },
    dispatch,
  );

const mapStateToProps = (state) => ({
  stripeApiKey: state.stripeApiKey,
  userSubscriptionDetails: state.userSubscriptionDetails,
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutContainer);
